export const items = [
    {
        text: 'V5 Document*',
        extraDescription: "*If you have owned the car for less than 6 months we will require a main dealer VAT invoice as proof of purchase. Any backdated ownership will also require this supporting documentation.",
        id: 1
    },
    {
        text: 'Outstanding finance letter*',
        extraDescription: "*If there is outstanding finance, a letter from the finance company confirming their settlement figure.",
        id: 2
    },
    {
        text: 'Drivers licence or passport',
        id: 3
    },
    {
        text: 'Proof of address within 90 days (e.g. utility bill)',
        id: 4
    },
    {
        text: 'Bank details (so we can pay you)',
        id: 5
    },
    {
        text: 'Two keys',
        id: 6
    },
    {
        text: 'Car handbook',
        id: 7
    },
    {
        text: 'Service and MOT history',
        id: 8
    }
]
